import { Grid, Skeleton } from '@mui/material'
import React from 'react'

const PrivaceStatementsSkeleton = () => {
    return (
        <>
            <Grid container flexDirection={"column"} padding={"20px"} gap={"10px"}>
                <Grid item sx={{ fontWeight: "bold", textAlign: "center", color: "#BBA57A", fontSize: "1rem", width: "100%" }}>قوانین و مقررات کمان لند</Grid>
                <Grid item sx={{ height: "80svh", overflowY: "auto" }}>
                    <Skeleton variant='rectangular' width={"100%"} height={"100%"} sx={{ transform: "unset" }} />
                </Grid>
                <Grid item>
                    <Skeleton variant='rectangular' width={"100%"} height={"100%"} sx={{ transform: "unset" }} />
                </Grid>
            </Grid>
        </>
    )
}

export default PrivaceStatementsSkeleton